import React from "react";
import { Modal, Form, Button, Input, Select } from "antd";
import {
  CountryType,
  CityPayloadType,
  CityType,
  StateProviceType,
} from "../types";
import { flush } from "redux-saga/effects";

interface CityState {
  cityName: string;
  cityNameError: boolean;
  mode: string;
  stateProvince: number;
  stateProvinceError: boolean;
}

interface CityProps {
  city: CityType | null;
  country: CountryType;
  province: StateProviceType;
  cities: any;
  stateProvinces: StateProviceType[];
  cityOf: string;
  close: () => any;
  createCity: (payload: CityPayloadType, cityOf: string) => any;
  updateCity: (cityID: number, payload: CityPayloadType, cityOf: string) => any;
}
const { Option } = Select;

const formPopUpLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};
const Mode = {
  ADD: "ADD",
  UPDATE: "UPDATE",
};
class City extends React.Component<CityProps, CityState> {
  constructor(props: CityProps) {
    super(props);
    const mode = !!props.city ? Mode.UPDATE : Mode.ADD;
    const cityName = !!props.city ? props.city.ciCity : "";

    this.state = {
      cityName,
      cityNameError: false,
      stateProvince: props.province && props.province.spId,
      stateProvinceError: false,
      mode,
    };
  }
  handleCityNameChange = (e) => {
    this.setState({ cityName: e.target.value, cityNameError: false });
  };

  isCityValid = () => {
    // city is validated based on if city and state combination is unique
    const { stateProvince, cityName } = this.state;

    const duplicateCities = this.props.cities.filter((item: CityType) => {
      if (item.ciStateProvinceRef) {
        return (
          item.ciCity.toLowerCase() === this.state.cityName.toLowerCase() &&
          item.ciStateProvinceRef === stateProvince
        );
      }
      return item.ciCity.toLowerCase() === this.state.cityName.toLowerCase();
    });

    let validCity = true;

    if (cityName === "" || duplicateCities.length > 0) {
      validCity = false;
      this.setState({
        cityNameError: true,
      });
    } else {
      this.setState({
        cityNameError: false,
      });
    }
    if (this.props.country.coSPCheck && !!this.state.stateProvince === false) {
      validCity = false;
      this.setState({
        stateProvinceError: true,
      });
    }
    return validCity;
  };

  createCity = () => {
    if (!this.isCityValid()) return;
    const payload = {
      ciCity: this.state.cityName,
      ciCountryRef: this.props.country.coId,
      ciStateProvinceRef: this.state.stateProvince,
    };
    this.props.createCity(payload, this.props.cityOf);
  };
  updateCity = () => {
    if (!this.isCityValid()) return;

    const cityID = this.props.city.ciId;
    const payload = {
      ciCity: this.state.cityName,
      ciCountryRef: this.props.country.coId,
      ciStateProvinceRef: this.state.stateProvince,
    };
    this.props.updateCity(cityID, payload, this.props.cityOf);
  };
  onStateProvinceChange = (stateProvince) => {
    this.setState({
      stateProvince,
      stateProvinceError: false,
      cityNameError: false,
    });
  };
  render() {
    const { country, province, stateProvinces } = this.props;
    const { cityName, mode } = this.state;
    return (
      <Modal
        title={`${mode === "ADD" ? "Create City" : "Edit City"}`}
        visible
        footer={null}
        onCancel={this.props.close}
        width={450}
        className='city-modal'
        maskClosable={false}
      >
        <Form {...formPopUpLayout}>
          <Form.Item label='Country' colon={false}>
            <Input readOnly value={country.coDescription} />
          </Form.Item>
          <Form.Item
            label='State province'
            colon={false}
            required={country.coSPCheck}
            validateStatus={this.state.stateProvinceError ? "error" : ""}
            help={
              this.state.stateProvinceError ? "State province is required." : ""
            }
          >
            {/* <Input readOnly value={province.spStateProvince} /> */}

            <Select
              allowClear
              style={{ width: "100%" }}
              value={this.state.stateProvince}
              showSearch
              filterOption={(input, option) =>
                option.props.children &&
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
              onChange={this.onStateProvinceChange}
              placeholder='Select a state province'
            >
              {stateProvinces &&
                stateProvinces.map((item) => {
                  return (
                    <Option value={item.spId} key={item.spId}>
                      {item.spDescription}
                    </Option>
                  );
                })}
            </Select>
          </Form.Item>
          <Form.Item
            label='City Name'
            colon={false}
            required
            validateStatus={this.state.cityNameError ? "error" : ""}
            help={
              this.state.cityNameError
                ? this.state.cityName === ""
                  ? "City is required."
                  : "City already exists."
                : ""
            }
          >
            <Input
              value={cityName}
              onChange={this.handleCityNameChange}
              maxLength={30}
            />
          </Form.Item>
        </Form>
        <div className='actions'>
          <Button onClick={this.props.close}>Close</Button>
          <Button
            onClick={mode === Mode.ADD ? this.createCity : this.updateCity}
            type='primary'
          >
            {mode === Mode.ADD ? "Add" : "Update"}
          </Button>
        </div>
      </Modal>
    );
  }
}

export default City;
